const axiosPackage = require('axios')
const { HttpsProxyAgent } = require('https-proxy-agent')
const { HttpProxyAgent } = require('http-proxy-agent')

function createAxiosProxyInstance() {
  const proxyUrl = process.env.HTTPS_PROXY || process.env.HTTP_PROXY
  const apiBaseURL = process.env.API_MTSBANK_HOST

  if (!apiBaseURL) {
    console.error('API_MTSBANK_HOST is empty — axios baseURL undefined')
  }

  return {
    apiBaseURL,
    axiosProxyInstance: axiosPackage.create({
      headers: {
        'Client-Id': process.env.CLIENT_ID || process.env.NEXT_PUBLIC_CLIENT_ID,
      },
      baseURL: apiBaseURL,
      ...(proxyUrl && {
        httpAgent: new HttpProxyAgent(proxyUrl),
        httpsAgent: new HttpsProxyAgent(proxyUrl),
        proxy: false,
      }),
    }),
  }
}

// lazy: не читать env на top-level до загрузки next.config / dotenv
let cached

function getAxios() {
  if (!cached) cached = createAxiosProxyInstance()
  return cached
}

module.exports = {
  get apiBaseURL() {
    return getAxios().apiBaseURL
  },
  get axiosProxyInstance() {
    return getAxios().axiosProxyInstance
  },
}
